import {
  vBoolean,
  vDate,
  vFallback,
  vNumber,
  vObject,
  vOptional,
  type vOutput,
  vPicklist,
} from '../validation/index.ts'
import { chatAiModels } from './ai.ts'

const chatSettingsSchema = vObject({
  tokenLimit: vOptional(vNumber()),
  model: vOptional(vPicklist(chatAiModels)),
})
// Internal settings schema - for admin-only settings
export const internalAccountSettingsSchema = vObject({
  shareQuoteData: vFallback(vBoolean(), true),
  restrictNewLtlCarriers: vFallback(vBoolean(), false),
  ndaSigned: vOptional(vDate()),
  chat: vOptional(chatSettingsSchema),
})

export type InternalAccountSettings = vOutput<
  typeof internalAccountSettingsSchema
>
